'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$() {
  this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_defaultMake$lzy1 = null;
  this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_defaultMakebitmap$1 = false;
  this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_make$lzy1 = null;
  this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_makebitmap$1 = false;
  this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_given_Conversion_Type_FrameworkDateTime$lzy1 = null;
  this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_given_Conversion_Type_FrameworkDateTimebitmap$1 = false;
  this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_CannotParseError$lzy1 = null;
  this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_CannotParseErrorbitmap$1 = false;
}
export { $c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$ as $c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$ };
$c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype.constructor = $c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$;
/** @constructor */
function $h_Lapp_data_types\uff3fgeneral$package$AppBuildTime$() {
}
export { $h_Lapp_data_types\uff3fgeneral$package$AppBuildTime$ as $h_Lapp_data_types\uff3fgeneral$package$AppBuildTime$ };
$h_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype = $c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype;
$c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_defaultMakebitmap$1)) {
    this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_defaultMake$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_defaultMakebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_defaultMake$lzy1;
});
$c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_makebitmap$1)) {
    this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_make$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_makebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_make$lzy1;
});
$c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype.given_Conversion_Type_FrameworkDateTime__s_Conversion = (function() {
  if ((!this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_given_Conversion_Type_FrameworkDateTimebitmap$1)) {
    this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_given_Conversion_Type_FrameworkDateTime$lzy1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDateTime$Newtype$$anon$4(this);
    this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_given_Conversion_Type_FrameworkDateTimebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_given_Conversion_Type_FrameworkDateTime$lzy1;
});
$c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype.CannotParseError__Lframework_data_FrameworkDateTime$Newtype$CannotParseError$ = (function() {
  if ((!this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_CannotParseErrorbitmap$1)) {
    this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_CannotParseError$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$(this);
    this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_CannotParseErrorbitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fgeneral$package$AppBuildTime$__f_CannotParseError$lzy1;
});
$c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
var $d_Lapp_data_types\uff3fgeneral$package$AppBuildTime$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$, "app.data.types_general$package$AppBuildTime$", ({
  Lapp_data_types\uff3fgeneral$package$AppBuildTime$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_data_FrameworkDateTime$Newtype: 1,
  Lyantl_Newtype$WithoutValidation: 1
}));
export { $d_Lapp_data_types\uff3fgeneral$package$AppBuildTime$ as $d_Lapp_data_types\uff3fgeneral$package$AppBuildTime$ };
var $n_Lapp_data_types\uff3fgeneral$package$AppBuildTime$;
function $m_Lapp_data_types\uff3fgeneral$package$AppBuildTime$() {
  if ((!$n_Lapp_data_types\uff3fgeneral$package$AppBuildTime$)) {
    $n_Lapp_data_types\uff3fgeneral$package$AppBuildTime$ = new $c_Lapp_data_types\uff3fgeneral$package$AppBuildTime$();
  }
  return $n_Lapp_data_types\uff3fgeneral$package$AppBuildTime$;
}
export { $m_Lapp_data_types\uff3fgeneral$package$AppBuildTime$ as $m_Lapp_data_types\uff3fgeneral$package$AppBuildTime$ };
//# sourceMappingURL=app.data.types_general$package$-App-Build-Time$.js.map
